// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DTADocumentContentSectionsInner
 */
export interface DTADocumentContentSectionsInner {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentSectionsInner
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentSectionsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentSectionsInner
     */
    title?: string;
}

/**
 * Check if a given object implements the DTADocumentContentSectionsInner interface.
 */
export function instanceOfDTADocumentContentSectionsInner(value: object): value is DTADocumentContentSectionsInner {
    return true;
}

export function DTADocumentContentSectionsInnerFromJSON(json: any): DTADocumentContentSectionsInner {
    return DTADocumentContentSectionsInnerFromJSONTyped(json, false);
}

export function DTADocumentContentSectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentSectionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'] == null ? undefined : json['content'],
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function DTADocumentContentSectionsInnerToJSON(json: any): DTADocumentContentSectionsInner {
    return DTADocumentContentSectionsInnerToJSONTyped(json, false);
}

export function DTADocumentContentSectionsInnerToJSONTyped(value?: DTADocumentContentSectionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'id': value['id'],
        'title': value['title'],
    };
}
